
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'

@Options({
    computed: {
        ...mapState(['userInfo', 'aid',])
    },
    data() {
        return {
            isApp: false,
            showResult: false,
        }
    },
    mounted() {
        this.isApp = COVERAPP.Attribute.isApp()
        this.$common.pageLoaded()
        this.$common.track('load', '进入打开红包页')
    },
    methods: {
        openClick() {
            this.showResult = true;
        },
        returnClick() {
            this.$router.back()
        },
    }
})
export default class Open extends Vue { }
